import React from 'react';

import AuthGuard from '../components/AuthGuard';

const withAuth = (roles = []) => (WrappedComponent) => (props) => (
  <AuthGuard roles={roles}><WrappedComponent {...props} /></AuthGuard>
);

export default withAuth;
